import { BaseDSLVisitor } from './baseDSL.visitor';
import { StreamPlainObject } from '../plainObjects/stream.plainObject';
import { TransformPlainObject } from '../plainObjects/transform.plainObject';
import { PartitionPlainObject } from '../plainObjects/partition.plainObject';
import { PARTITION_FUNCTION_CONSTANT } from '../constants';

/* eslint-disable @typescript-eslint/no-explicit-any */
export abstract class BaseTransformationVisitor extends BaseDSLVisitor {
    constructor(protected _tokenStream: any, public transformation: TransformPlainObject) {
        super(_tokenStream);
    }

    public visitTransformation(transformationContext: any): void {
        this.visitChildren(transformationContext);
    }

    public visitFunctionExpr(context: any): any {
        if (context.basicFunction().basicName().getText() === PARTITION_FUNCTION_CONSTANT) {
            this.getPartitionProperties(context);
        } else {
            this.visitChildren(context);
        }
    }

    public visitMetafunction(context: any): any {
        this.visitChildren(context);
    }

    public visitMetaFunctionExpr(context: any): any {
        this.visitChildren(context);
    }

    public visitBasicFunction(context: any): any {
        this.visitChildren(context);
    }

    public visitFlowStatement(flowStatementContext: any): void {
        if (flowStatementContext.inputTransformedList()) {
            this.visit(flowStatementContext.inputTransformedList());
        }
        this.visit(flowStatementContext.transformation());
        this.visit(flowStatementContext.outputTransformed());
    }

    public visitInputTransformedList(inputTransformedListContext: any): void {
        this.transformation.inputStreams.push(...inputTransformedListContext.children.map(
            (child: any) => this.visit(child)).filter((inputStreamName: string) => !!inputStreamName)
            .map((name: string) => new StreamPlainObject(name)));
    }

    public visitOutputTransformed(outputTransformedContext: any): void {
        this.transformation.name = this.visit(outputTransformedContext.transformed());
        const outputStream = new StreamPlainObject();
        this.transformation.outputStreams.push(outputStream);
    }

    public visitTransformed(transformedContext: any): string {
        return this._getText(transformedContext);
    }

    public visitTransformedGroup(transformedGroupContext: any): string {
        return this._getText(transformedGroupContext);
    }

    public visitConfiguration(configurationContext: any): void {
        const configName: string = this._getText(configurationContext.configName());
        const expression: string = this._getText(configurationContext.expression());
        this.transformation.configs.set(configName, expression);
    }

    protected getPartitionProperties(context: any): void {
        const expressions = context.basicFunction().expression();
        if (this.transformation) {
            const method = expressions[0].getText() as string;
            this.transformation.partition = new PartitionPlainObject();
            this.transformation.partition.partitionMethod = method.substring(1, method.length - 1);
            this.transformation.partition.numberOfPartitions = expressions[1].getText() as string;

            for (let expIndex = 2; expIndex < expressions.length; expIndex++) {
                const condition = expressions[expIndex].getText();
                if (condition) {
                    this.transformation.partition.conditions.push(condition);
                }
            }
        }
    }
}
